import React, { useState, useEffect } from 'react';
import { Absolute, Text, CloseButton, Flex } from 'pcln-design-system';
import styled, { keyframes, css } from 'styled-components';
const NotificationBox = /*#__PURE__*/styled(Flex).withConfig({
  displayName: "ChatBotPopOver__NotificationBox",
  componentId: "sc-9p9v30-0"
})(["position:fixed;align-items:center;border-radius:6px 12px 20px 24px;cursor:pointer;"]);
const fadeInFromBottomToTopAnimation = props => {
  const animation = /*#__PURE__*/keyframes(["from{transform:translate(", ",", ");-webkit-transform:translate(", ",", ");opacity:0;}to{transform:translate(", ",", ");opacity:1;}"], props.fromX, props.fromY, props.fromX, props.fromY, props.toX, props.toY);
  return css(["position:relative;animation:", ";animation-duration:0.4s;animation-fill-mode:forwards;animation-timing-function:cubic-bezier(0,0,0.3,1);"], animation);
};
const AnimateBottomToTop = /*#__PURE__*/styled.div.withConfig({
  displayName: "ChatBotPopOver__AnimateBottomToTop",
  componentId: "sc-9p9v30-1"
})(["", " position:absolute;bottom:0;right:15px;width:100%;height:100%;"], fadeInFromBottomToTopAnimation);
const AnimateComponent = ({
  children,
  animationProperties,
  animationType
}) => {
  if (animationType === 'BottomToTopLeft' || animationType === 'RightToLeft') {
    const {
      bottom,
      from,
      to
    } = animationProperties;
    return React.createElement(AnimateBottomToTop, {
      fromX: from.x,
      fromY: from.y,
      toX: to.x,
      toY: to.y,
      bottom: bottom
    }, children);
  }
  return children;
};
/**
 * ChatBotPopOver
 * chat notification popover
 * @public
 */
export function ChatBotPopOver(props) {
  const {
    onClose,
    onOpen,
    onDisplay,
    text,
    positionProps,
    containerProps,
    animationType = 'None',
    animationProperties,
    source,
    isFrequentNotification
  } = props;
  const {
    zIndex,
    bottom,
    right
  } = positionProps !== null && positionProps !== void 0 ? positionProps : {};
  const {
    width = '300px'
  } = containerProps !== null && containerProps !== void 0 ? containerProps : {};
  const [hidePopOver, setHidePopOver] = useState(true);
  const today = new Date();
  const startOfWeek = new Date(today);
  startOfWeek.setDate(today.getDate() - today.getDay());
  startOfWeek.setHours(0, 0, 0, 0);
  useEffect(() => {
    const homePagePopoverLastSaved = localStorage.getItem('homePagePopoverLastSaved');
    const shouldNotShowHomePagePopOver = localStorage.getItem('shouldNotShowHomePagePopOver');
    const homePagePopoverLastSavedDate = homePagePopoverLastSaved ? new Date(homePagePopoverLastSaved) : null;
    if (isFrequentNotification && homePagePopoverLastSavedDate && shouldNotShowHomePagePopOver) {
      if (source === 'homepage' && shouldNotShowHomePagePopOver === 'false') {
        setHidePopOver(false);
      } else if (source !== 'homepage') {
        setHidePopOver(false);
      } else {
        if (homePagePopoverLastSavedDate && homePagePopoverLastSavedDate < startOfWeek) {
          localStorage.setItem('shouldNotShowHomePagePopOver', 'false');
          localStorage.setItem('homePagePopoverLastSaved', today.toString());
          setHidePopOver(false);
        } else {
          setHidePopOver(true);
        }
      }
    } else {
      setHidePopOver(false);
    }
  }, [isFrequentNotification]);
  const handleHomePageClose = () => {
    if (source === 'homepage' && isFrequentNotification) {
      localStorage.setItem('shouldNotShowHomePagePopOver', 'true');
      localStorage.setItem('homePagePopoverLastSaved', today.toString());
    }
  };
  useEffect(() => {
    if (hidePopOver === false && typeof onDisplay === 'function') {
      onDisplay();
    }
  }, [hidePopOver, onDisplay]);
  if (hidePopOver) {
    return null;
  }
  return React.createElement(AnimateComponent, {
    animationType: animationType,
    animationProperties: animationProperties
  }, React.createElement(Absolute, {
    bottom: bottom,
    right: right,
    zIndex: zIndex,
    width: width
  }, React.createElement(NotificationBox, {
    pt: 3,
    pb: 3,
    px: 3,
    boxShadow: 'lg',
    background: 'background.lightest',
    color: 'text.base',
    onClick: function (e) {
      e.stopPropagation();
      e.preventDefault();
      onOpen();
    }
  }, React.createElement(Absolute, {
    bottom: '55px',
    right: '-10px'
  }, React.createElement(CloseButton, {
    "data-testid": 'CHATBOT_POPOVER_CLOSEBUTTON',
    title: 'close',
    variant: 'filled',
    size: 'md',
    onClick: function (e) {
      e.stopPropagation();
      e.preventDefault();
      handleHomePageClose();
      onClose();
    }
  })), React.createElement(Text, {
    fontSize: 1
  }, text))));
}